'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var scrollToElement = require('scroll-to-element');
var domCache = require('dom-cache');

var addEventHandlers = function(){

	domCache.document.on('click', '[data-scroll-to]', function(){

		scrollToElement({
			element: $(this).attr('data-scroll-to'),
			force: true
		});

	});

};

var init = function(){

	addEventHandlers();

};

module.exports = {
	init: init
};
